export default "__VITE_ASSET__f1lxwZuc__"